import { CurrentUser } from "@/types/user"

export function showRegisterGateForCreatorReferral(
  currentUser: CurrentUser | undefined | null,
  utm_campaign: string | undefined | null,
  utm_source: string | undefined | null,
  utm_medium: string | undefined | null
) {
  return (
    (!currentUser || currentUser.provider === "anonymous") &&
    utm_campaign === "creator_refer_pages" &&
    utm_source === "creator" &&
    utm_medium === "social"
  )
}
